<template>
  <div class="require-auth-component">

    <div v-if="showTitle" class="title-block">

      <slot name="title">
        <h3>
          {{ tu("user.requireAuthComponent.title") }}
        </h3>
      </slot>
    </div>
    <div v-if="showExplainText" class="explain-text-block">
      <slot name="before-cta">
        <p>
          {{ tu("user.requireAuthComponent.explain") }}
        </p>
      </slot>
    </div>

    <div class="cta-block">
      <slot name="cta" v-bind="{ redirectToLogin, redirectToRegister }">
        <div class="actions-wrapper flex-start margin-2xl-top">
          <div
            class="flex flex-middle flex-center gap-l flex-wrap m:flex-nowrap">
            <form-button
              icon="arrow-login-inline-end"
              text="user.requireAuthComponent.loginCta"
              @click="redirectToLogin()"></form-button>
            <span class="flex actions-separator">{{
              tu("user.requireAuthComponent.or")
            }}</span>
            <form-button
              icon="user"
              text="user.requireAuthComponent.registerCta"
              @click="redirectToRegister()"></form-button>
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    redirect: {
      // goes to login view. Can be relative URL or route name
      type: [String, Boolean, null],
      default: null,
    },
    redirectParams: {
      type: Object,
      default: () => {},
    },
    loginRouteName: {
      type: String,
      default: "user-login",
    },
    registerRouteName: {
      type: String,
      default: "user-register",
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
    showExplainText: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {};
  },
  methods: {
    redirectToLogin() {
      this.$router.push({
        name: this.loginRouteName,
        query: this.finalRedirectQuery,
      });
    },
    redirectToRegister() {
      this.$router.push({
        name: this.registerRouteName,
        query: this.finalRedirectQuery,
      });
    },
  },
  computed: {
    finalRedirectQuery() {
      if (this.redirect === false) {
        return  {}
      }

      if (this.redirect) {
        return {
          redirect: this.redirect,
          redirectParams: this.redirectParams,
        };
      }

      return this.currentRouteRedirectQuery;
    },
    currentRouteRedirectQuery() {
      let params = this.$route.query.redirectParams
        ? this.$route.query.redirectParams
        : false;
      return {
        redirect: this.$route.fullPath,
        redirectParams: params,
      };

    }
  },
};
</script>

<style scoped lang="scss">
@media (max-width: 767px) {
  .actions-separator {
    flex: 100%;
    text-align: center;
    justify-content: center;
    align-items: center;
  }
}
</style>
